
/* Brentos low-stock indicator */

(function () {

  function initLowStock(indicator) {

    if (indicator.dataset.initialised === 'true') return;

    const dataElement = indicator.querySelector(
      '[data-stock-variants]'
    );

    if (!dataElement) return;

    const productForm = indicator.closest('product-form');

    if (!productForm) return;

    const variants = JSON.parse(dataElement.textContent);

    const threshold = Number(indicator.dataset.threshold);
    const barMax = Number(indicator.dataset.barMax);

    const message = indicator.querySelector(
      '[data-stock-message]'
    );

    const fill = indicator.querySelector(
      '[data-stock-fill]'
    );

    function update() {

      const selectedInput = productForm.querySelector(
        'input[name="id"]:not([disabled]), select[name="id"]'
      );

      const variant = selectedInput
        ? variants[selectedInput.value]
        : null;

      if (
        !variant ||
        !variant.tracked ||
        variant.policy === 'continue' ||
        !variant.available ||
        variant.quantity <= 0 ||
        variant.quantity > threshold
      ) {
        indicator.hidden = true;
        return;
      }

      const quantity = variant.quantity;

      indicator.hidden = false;

      indicator.classList.toggle(
        'is-low',
        quantity <= 30
      );

      indicator.classList.toggle(
        'is-critical',
        quantity <= 10
      );

      message.textContent = quantity <= 10
        ? `Almost gone! Only ${quantity} left`
        : `Only ${quantity} left in stock`;

      const percentage = Math.min(
        100,
        Math.max(0, (quantity / barMax) * 100)
      );

      fill.style.width = `${percentage}%`;

    }

    // Local 4.2.1 dispatches VARIANT_CHANGE from
    // the product-variants element after updating
    // the selected variant ID.

    const productPage = productForm.closest(
      '[data-js-product-component]'
    );

    const variantPicker = productPage?.querySelector(
      'product-variants'
    );

    if (variantPicker) {
      variantPicker.addEventListener(
        'VARIANT_CHANGE',
        update
      );
    }

    // Display the initial inventory.
    update();

    indicator.dataset.initialised = 'true';

  }

  function initAll() {

    document.querySelectorAll(
      '[data-brentos-low-stock]'
    ).forEach(initLowStock);

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }

  document.addEventListener(
    'shopify:section:load',
    initAll
  );

})();
